import { DialogContent, Typography } from "@mui/material";
import React from "react";
import { Done } from "@mui/icons-material";
import { t } from "i18next";

interface IOperationDataReportConfirmProps {
    ticketNumber: string;
}

export const OperationDataReportSuccess = (props: IOperationDataReportConfirmProps) => {
    return <DialogContent className={"report-popup"}>
        <div className={"report-popup__icon"}>
            <Done color={"success"} />
        </div>
        <div className={"report-popup__details"}>
            <Typography className={"report-popup__title"}>
                {props.ticketNumber}
            </Typography>
            <Typography>
                {t("components.operationDataValidation.report.popup.success")}
            </Typography>
        </div>
    </DialogContent>;
};
